import React from "react"

export default function Send() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
         <path d="M2.1153 17.463L19.5619 9.98301C20.3717 9.63301 20.3717 8.49301 19.5619 8.14301L2.1153 0.663005C1.45543 0.373005 0.725574 0.863005 0.725574 1.57301L0.715576 6.18301C0.715576 6.68301 1.0855 7.11301 1.58541 7.17301L15.7126 9.06301L1.58541 10.943C1.0855 11.013 0.715576 11.443 0.715576 11.943L0.725574 16.553C0.725574 17.263 1.45543 17.753 2.1153 17.463V17.463Z" fill="#653fd5" />
      </svg>
   )
}